import { getFormattingConfig, formatNumber, pluralize } from './chunk-SUNYEKTQ.js';
import { resolveTranslator } from './chunk-RRFUPILC.js';
import { useState, useEffect } from 'react';

function getCurrentBreakpoint() {
  if (typeof window === "undefined") return "lg";
  if (window.matchMedia("(max-width: 520px)").matches) return "sm";
  if (window.matchMedia("(max-width: 900px)").matches) return "md";
  return "lg";
}
function useBreakpoint() {
  const [bp, setBp] = useState(getCurrentBreakpoint);
  useEffect(() => {
    const smMq = window.matchMedia("(max-width: 520px)");
    const mdMq = window.matchMedia("(max-width: 900px)");
    function update() {
      setBp(getCurrentBreakpoint());
    }
    smMq.addEventListener("change", update);
    mdMq.addEventListener("change", update);
    return () => {
      smMq.removeEventListener("change", update);
      mdMq.removeEventListener("change", update);
    };
  }, []);
  return bp;
}

// src/internal/components/Pagination/summary.ts
var defaultT = resolveTranslator(void 0);
function resolveNoun(total, options, t, locale) {
  const forms = options.nounForms ?? [t("pagination.nounOne"), t("pagination.nounFew"), t("pagination.nounMany")];
  return pluralize(total, locale, {
    one: forms[0],
    few: forms[1],
    many: forms[2],
    other: forms[2]
  });
}
function formatPageSummary(input, options = {}) {
  if (input.total <= 0) return void 0;
  if (input.totalPages > 0 && input.page > input.totalPages) return void 0;
  const t = options.t ?? defaultT;
  const locale = options.locale ?? getFormattingConfig().locale;
  const noun = resolveNoun(input.total, options, t, locale);
  const params = {
    count: formatNumber(input.total),
    noun,
    page: formatNumber(input.page),
    totalPages: formatNumber(input.totalPages)
  };
  return input.totalPages > 0 ? t("pagination.summaryWithTotal", params) : t("pagination.summary", params);
}
function formatPageRangeSummary(input, options = {}) {
  if (input.total <= 0) return void 0;
  const start = (input.page - 1) * input.perPage + 1;
  if (start > input.total) return void 0;
  const end = Math.min(input.page * input.perPage, input.total);
  const t = options.t ?? defaultT;
  const locale = options.locale ?? getFormattingConfig().locale;
  const includeNoun = Boolean(options.nounForms);
  const params = {
    start: formatNumber(start),
    end: formatNumber(end),
    total: formatNumber(input.total)
  };
  if (includeNoun) {
    params.noun = resolveNoun(input.total, options, t, locale);
    return t("pagination.rangeWithNoun", params);
  }
  return t("pagination.range", params);
}

export { formatPageRangeSummary, formatPageSummary, useBreakpoint };
//# sourceMappingURL=chunk-FUVISKLY.js.map
//# sourceMappingURL=chunk-FUVISKLY.js.map